const pollState = {
  title: 'Poll title',
  description: 'Choose the best option',
  engagementData: {
    engagementType: 'poll',
    options: [{ title: '' }, { title: '' }],
    engagementTemplate: 'pollOne',
  },
};
export default pollState;
